<template>
  <div>
    <v-card>
      <v-card-title>
      <v-icon color="primary">
        mdi-credit-card-outline
      </v-icon>
        <span class="pl-2">{{ $t('payments.title') }}</span>
        <v-spacer></v-spacer>
        <v-chip color="primary" text-color="white" class="mr-2">
          {{ $t('payments.total_paid', { amount: totalPaid }) }}
        </v-chip>
      </v-card-title>
      <v-data-table
        item-key="id"
        :loading="isLoading"
        :loading-text="$t('common.loading_wait')"
        :headers="headers"
        :items="payments"
        :search="search"
       :no-data-text="$t('common.no_data')">
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('common.search')"
            class="mx-4"
          ></v-text-field>
        </template>

        <template v-slot:item.payment_date="{ item }">
          {{ item.payment_date | moment("LL") }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      payments: [],
      totalPaid: 0,
      isLoading: false,
      search: "",
      headers: [
        { text: this.$t('payments.id'), value: "id", align: "start", filterable: false },
        { text: this.$t('payments.plan'), value: "plan_name" },
        { text: this.$t('payments.paid_price'), value: "price" },
        { text: this.$t('payments.coins'), value: "coin_count" },
        { text: this.$t('payments.date'), value: "payment_date" },
      ],
    };
  },
  mounted() {
    this.loadPayments();
  },
  methods: {
    loadPayments() {
      this.isLoading = true;
      this.payments = [];
      axios
        .get(`/charges/school`)
        .then((response) => {
          this.payments = response.data.charges;
          this.totalPaid = response.data.totalPaid;
        })
        .catch((error) => {
          this.$notify({
            title: "",
            text: this.$t('payments.error_retrieving_payments'),
            type: "error",
          });
          console.log(error);
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    viewUpcomingPayment(payment)
    {
      this.$router.push({
        name: "view-upcoming-payment",
        params: {
          user_id: payment.id,
        },
      });
    },
    redeemPayment(index) {
      this.$swal({
        title: this.$t('payments.redeem_title'),
        html: this.$t('payments.redeem_confirm', { amount: this.payments[index].total_amount, user: this.payments[index].user_name }) + "<br/><br/>" +
        this.showRedemptionDetails(index),
        icon: "warning",
        footer: this.showRedemptionFooter(index),
        showCancelButton: true,
        confirmButtonText: this.$t('payments.redeem_confirm_btn'),
      }).then((result) => {
        if (result.isConfirmed) {
          this.redeemPaymentServer(this.payments[index].id, index);
        }
      });
    },

    showRedemptionFooter(index)
    {
      let redemption_preference = this.payments[index].redemption_preference;
      if(redemption_preference==2)
      {
        return '<h2>' + this.$t('payments.bank_account') + '</h2>';
      }
      else if(redemption_preference==3)
      {
        return '<h2>' + this.$t('payments.paypal') + '</h2>';
      }
      else if(redemption_preference==4)
      {
        return '<h2>' + this.$t('payments.mobile_money') + '</h2>';
      }
      else
      {
        return '<h2>' + this.$t('payments.cash') + '</h2>';
      }
    },
    showRedemptionDetails(index)
    {
      let redemption_preference = this.payments[index].redemption_preference;
      console.log(redemption_preference);
      if(redemption_preference==2)
      {
        return '<ul><li><b>' + this.$t('payments.bank_name') + ':</b> ' + this.payments[index].redemption_details.bank_name + '</li>' +
        '<li><b>' + this.$t('payments.account_number') + ':</b> ' + this.payments[index].redemption_details.account_number + '</li>' +
        '<li><b>' + this.$t('payments.beneficiary_name') + ':</b> ' + this.payments[index].redemption_details.beneficiary_name + '</li>' +
        '<li><b>' + this.$t('payments.beneficiary_address') + ':</b> ' + this.payments[index].redemption_details.beneficiary_address + '</li>' +
        (this.payments[index].redemption_details.iban != null ? '<li><b>' + this.$t('payments.iban') + ':</b> ' + this.payments[index].redemption_details.iban + '</li>' : '') +
        (this.payments[index].redemption_details.swift != null ? '<li><b>' + this.$t('payments.swift') + ':</b> ' + this.payments[index].redemption_details.swift + '</li>' : '') +
        (this.payments[index].redemption_details.routing_number != null ? '<li><b>' + this.$t('payments.routing_number') + ':</b> ' + this.payments[index].redemption_details.routing_number + '</li>' : '') +
        (this.payments[index].redemption_details.bic != null ? '<li><b>' + this.$t('payments.bic') + ':</b> ' + this.payments[index].redemption_details.bic + '</li>' : '') +
        '</ul>';
      }
      else if(redemption_preference==3)
      {
        return "<b>" + this.$t('payments.paypal') + ":</b> " + this.payments[index].redemption_details.email;
      }
      else if(redemption_preference==4)
      {
        return '<ul><li><b>' + this.$t('payments.phone_number') + ':</b> ' + this.payments[index].redemption_details.phone_number + '</li>' +
        '<li><b>' + this.$t('payments.network') + ':</b> ' + this.payments[index].redemption_details.network + '</li>' +
        '<li><b>' + this.$t('payments.name') + ':</b> ' + this.payments[index].redemption_details.name + '</li>' +
        '</ul>';
      }
      else
      {
        return "";
      }
    },

    redeemPaymentServer(user_id, index) {
      this.isLoading = true;
      axios
        .post(`/users/redeem`, {
          user_id: user_id,
        })
        .then((response) => {
          this.$notify({
            title: "",
            text: this.$t('payments.payment_redeemed'),
            type: "success",
          });
          this.payments.splice(index, 1);
        })
        .catch((error) => {
          this.$notify({
            title: "",
            text: this.$t('payments.error_redeeming'),
            type: "error",
          });
          console.log(error);
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled):hover{
  cursor: pointer;
  background: rgba($primary-shade--light, 0.15) !important;
}
</style>
